<template>
  <v-row
    class="recommendation-cards-container d-flex justify-space-between flex-grow-0"
    :class="rowClasses"
    :style="rowStyle"
    data-test-id="recommendation-cards"
  >
    <v-col
      v-for="(message, index) in visibleMessages"
      :key="`${message.action}-${index}`"
      :cols="colSize"
      class="card-col col"
    >
      <RecommendationCard
        :title="message.title"
        :content="message.content"
        :icon="message.icon"
        :icon-color="message.iconColor"
        @click="handleClick(message)"
      />
    </v-col>
  </v-row>
</template>

<script>
import RecommendationCard from "./RecommendationCard.vue";

import { mapState } from "vuex";

export default {
  name: "RecommendationCards",
  components: {
    RecommendationCard,
  },
  props: {
    messages: {
      type: Array,
      required: true,
      validator: (messages) => {
        return messages.every((message) => message.title && message.content && message.icon);
      },
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    maxCards: {
      type: Number,
      default: 3,
    },
    filterByPermission: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["card-action"],
  computed: {
    ...mapState(["permissions"]),
    visibleMessages() {
      let filtered = this.messages;

      // Filter by permissions if enabled
      if (this.filterByPermission && this.permissions.length > 0) {
        filtered = filtered.filter((message) => this.permissions.includes(message.permission));
      }

      // Limit number of cards
      return filtered.slice(0, this.maxCards);
    },
    rowClasses() {
      return {
        "flex-column mt-2": this.isMobile,
      };
    },
    rowStyle() {
      return {
        "min-height": "175px",
        height: "fit-content",
      };
    },
    colSize() {
      if (this.isMobile) return 12;

      // Responsive column sizing based on number of cards.
      // Cap at 3 columns per row so 4+ cards wrap into additional rows
      // instead of getting squeezed into a single row.
      const cardCount = this.visibleMessages.length;
      if (cardCount === 1) return 12;
      if (cardCount === 2) return 6;
      return 4;
    },
  },
  methods: {
    handleClick(message) {
      this.$emit("card-action", message);
    },
  },
};
</script>

<style scoped>
.recommendation-cards-container {
  margin-bottom: 12px;
}

.card-col {
  padding-top: 8px;
  padding-bottom: 8px;
}

/* Mobile adjustments */
@media (max-width: 960px) {
  .recommendation-cards-container {
    margin-bottom: 0px;
  }

  .card-col {
    padding-top: 4px;
    padding-bottom: 4px;
  }
}
</style>
